<template>
  <sds-modal
    :value="true"
    title="Alterar Datas do Parecer"
    @fechar="emit('fechar')"
  >
    <v-row dense>
      <v-col cols="6">
        <SdsDateField
          :value="modalAlterarDatas.dtAlteracao"
          disabled
          filled
          label="Data de Alteração:"
          style="max-width: 300px"
          data-testid="date-dtAlteracao"
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="6">
        <SdsDateField
          v-model="modalAlterarDatas.dtParecer"
          :max="moment().format('DD/MM/YYYY')"
          label="Nova Aprovação da Presidência*:"
          required
          data-testid="date-dtParecer"
          label-greater-than-maximum="A aprovação da Presidência não pode ser maior do que a data atual."
        />
      </v-col>
      <v-col cols="6">
        <SdsDateField
          class="ml-4"
          v-model="modalAlterarDatas.dtValidade"
          label="Nova Data de Validade*:"
          :min="
            moment(modalAlterarDatas.dtParecer, 'DD/MM/YYYY')
              .add(1, 'day')
              .format('DD/MM/YYYY')
          "
          :max="maxDtValidadeModalAlterarDatas"
          label-less-than-minimum="Data de validade não pode ser igual ou inferior à aprovação da Presidência."
          label-greater-than-maximum="Data de validade do parecer não poderá ser superior a 2 anos"
          data-testid="date-dtValidade"
        />
      </v-col>
    </v-row>

    <template #modal-actions-right>
      <div class="mt-3 mb-4">
        <v-btn
          class="mr-2"
          text
          color="primary"
          @click="emit('fechar')"
          data-testid="btn-cancelar-modal-alterar-datas"
        >
          Cancelar
        </v-btn>
        <v-btn
          depressed
          color="primary"
          @click="store.adicionarAlteracaoDatas()"
          data-testid="btn-salvar-modal-alterar-datas"
        >
          Salvar
        </v-btn>
      </div>
    </template>
  </sds-modal>
</template>

<script setup lang="ts">
import SdsDateField from '@/components/SdsDateField.vue';
import moment from 'moment';
import { useCadastroParecerReferencialStore } from '../../store/CadastroParecerReferencialStore';
import { storeToRefs } from 'pinia';
import { watch } from 'vue';

const store = useCadastroParecerReferencialStore();
const { modalAlterarDatas, maxDtValidadeModalAlterarDatas } =
  storeToRefs(store);

const emit = defineEmits(['fechar']);

watch(
  () => modalAlterarDatas.value.dtParecer,
  async () => {
    await store.calcularDtValidade(true);
  }
);
</script>
